import React from "react";
import "./TaxiMainDetails.css"; // קובץ CSS לעיצוב

const TaxiMainDetails = ({ taxi }) => {
    if (!taxi) return <p>🚕 נתונים לא זמינים</p>;

    return (
        <div className="taxi-main-details">
            <div className="TaxiForsaleTitle">
            <h2> {taxi["יצרן"]} {taxi["דגם"]}</h2>
            <h3 className="locationtaxiforsale">{taxi["אזור_מגורים"]}</h3>
            </div>
            <div className="TaxiforsaleMainDetails">
            <p><strong></strong> {taxi["שנתון"]}</p>
            <p><strong>יד</strong> {taxi["יד"]}</p>
            <p><strong>ק"מ</strong> {taxi["קמ"]}</p>
            </div>
        </div>
    );
};

export default TaxiMainDetails;
